import React, { useEffect, useState } from "react";
import { useConsultCall } from "./store";
import { fourPlaceHolder, getFormattedDate } from "modules/utilities/utility";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { Link } from "react-router-dom";
import CardDiv from "modules/common/card-div/CardDiv";
import { Table } from "react-bootstrap";
import { Tag } from "antd";

function ConsultCallBookings({ subTab }) {
  const [consultCalls, setConsultCalls] = useState({});
  const [page, newPage] = useState(1);
  const { fetchConsultCallData, consultCallData, consultLoading } =
    useConsultCall();
  const [pagination, setPagination] = useState();
  useEffect(() => {
    if (subTab == "consultCall") {
      fetchConsultCallData(page);
    }
  }, [page, subTab]);
  useEffect(() => {
    if (consultCallData && consultCallData.data && consultCallData.pagination) {
      setConsultCalls(consultCallData?.data);
      setPagination(consultCallData.pagination);
    }
  }, [consultCallData]);

  return (
    <div>
      {consultLoading ? (
        fourPlaceHolder()
      ) : consultCalls && consultCalls?.length ? (
        <>
          <Table striped responsive>
            <thead className="border-bottom fw-bold">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Phone</th>
                <th scope="col">Email</th>
                <th scope="col">Tag</th>
                <th scope="col">Time</th>
              </tr>
            </thead>
            <tbody>
              {consultCallData &&
                consultCallData?.data.map((call, index) => {
                  return (
                    <tr>
                      <td>
                        <div className="d-flex flex-column gap-1">
                          <Link to={`/lead-details/${call?.id}`}>
                            {call.user.first_name}{" "}
                          </Link>
                        </div>
                      </td>
                      <td>{call.user.phone_number}</td>
                      <td>{call.user.email}</td>
                      <td>
                        <Tag bordered={false} color="processing">
                          Consult Booking
                        </Tag>
                      </td>
                      <td>{getFormattedDate(call.consult_call_due_date)}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          <PaginationDiv newPage={newPage} paginationData={pagination} />
        </>
      ) : (
        <CardDiv
          component={
            <h4 className="fw-bold text-center text-secondary">
              No Consult Booking available
            </h4>
          }
        />
      )}
    </div>
  );
}

export default ConsultCallBookings;
